import logoNav from '../../images/LogoSmallColored-nav.png';
import { useApi } from '../Store/ApiContext';

export default function Footer() {
    const { getSlug } = useApi();

    function checkSlugOrganization() {
        const slug = getSlug();
        if (slug == "ghouse.stminaelmandara.com") {
            return false
        }
        return true
    }

    return (
        checkSlugOrganization() ? <footer>
            <a target="_blank" href='https://egarhub.com/' className="d-flex d-xs-inline-block justify-content-between align-items-center px-3 footer">
                <div className='fs-footer'>
                    <p>جميع الحقوق محفوظة.</p>
                </div>
                <div className='d-flex align-items-center '>
                    <p className='p-2 fs-footer'>© Egarhub</p>
                    <div>
                        <img className='w-100 p-2 logo-footer' src={logoNav} alt='egarhub' />
                    </div>
                </div>
            </a>
        </footer> : <></>
    )
}
